import React from 'react'
import {Box, Text} from '../../../../vanilla'
import {useBasketStore} from '../../../../store/hooks/useStore'
import {Countdown} from '../../../book-delivery/reservation-status'
import {observer} from 'mobx-react'

export const ReservationDetails = observer(() => {
  const {basket} = useBasketStore()

  return (
    <Box
      bg="gray75"
      borderRadius="medium"
      paddingX="8px"
      paddingY="6px"
      marginTop="12px"
      width="full"
    >
      <Text
        variant="text1"
        color="gray800"
        lineHeight="short"
        align="center"
        data-test-selector="delivery-address-summary"
      >
        Checkout in the next:{' '}
        <Countdown color="accent0" textVariant="text2" slotExpiration={basket?.c_slotExpiryTime || ''} />
      </Text>
    </Box>
  )
})
